import { FC, ReactElement } from "react";
import "./CardContainer.scss";

export interface Props {
    title: string;
    addClass: string;
    icon?: string | ReactElement;
    contentAddClass?: string;
}

const CardContainer: FC<React.PropsWithChildren<Props>> = (props) => {
    function renderIcon() {
        const isString = typeof props.icon === "string";
        return <div className="card-container__icon">{!isString && props.icon}</div>;
    }

    return (
        <div className={`card-container ${props.addClass}`}>
            {renderIcon()}
            <div className={`card-container__content ${props.contentAddClass}`}>
                <div className="card-container__title">{props.title}</div>
                {props.children}
            </div>
        </div>
    );
};

export default CardContainer;
